import ReactModal from 'react-modal'
import './_Modal.scss'
import { useFeatureFlagVariantKey } from 'posthog-js/react'
import { FEATURE_FLAGS } from '../../hooks/featureFlags'

function Modal({
	open,
	closeModal,
	children,
	portalClassName,
	omitClose = false,
}: {
	open: boolean
	closeModal: () => void
	children: React.ReactNode
	portalClassName?: string
	omitClose?: boolean
}) {
	return (
		<ReactModal
			isOpen={open}
			ariaHideApp={false}
			onRequestClose={() => {
				closeModal()
			}}
			portalClassName={`${portalClassName} rounded modal-animated`}
			closeTimeoutMS={100}
		>
			{!omitClose && (
				<div className="close" onClick={closeModal}>
					&times;
				</div>
			)}
			{children}
		</ReactModal>
	)
}

export default Modal
